import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";

// MSAL imports
import {
  PublicClientApplication,
  EventType,
  type EventMessage,
  type AuthenticationResult,
} from "@azure/msal-browser";
import { getConfig, msalConfig } from "./authConfig";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";
import { AuthProvider } from "@fdoh/api-client";
// import { AuthProvider } from "./components/AuthProvider";
import { ConfigurationProvider } from "@fdoh/api-client";
import { ThemeProvider } from "./components/theme/ThemeProvider";

// Import custom styles (Tabler is imported in flehs.scss)
import "./scss/flehs.scss";

// Create a new router instance
const router = createRouter({ routeTree });

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);

    // Try to silently acquire tokens on app startup - separate requests for each resource
    const graphRequest = {
      scopes: ["https://graph.microsoft.com/User.Read"],
      account: accounts[0],
      forceRefresh: false,
    };

    const flehsRequest = {
      scopes: ["api://5b9d1c95-aa2d-4545-af3f-72cc38b875f4/Flehs.User"],
      account: accounts[0],
      forceRefresh: false,
    };

    // Request Graph token
    msalInstance.acquireTokenSilent(graphRequest).catch(() => {
      // Silent acquisition may fail, token will be requested when needed
    });

    // Request FLEHS token
    msalInstance.acquireTokenSilent(flehsRequest).catch(() => {
      // Silent acquisition may fail, token will be requested when needed
    });
  }

  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
    }
  });

  // Render the app
  const rootElement = document.getElementById("root")!;
  if (!rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <StrictMode>
        <ConfigurationProvider config={getConfig()}>
          <AuthProvider msalInstance={msalInstance}>
            <ThemeProvider>
              <RouterProvider router={router} />
            </ThemeProvider>
          </AuthProvider>
        </ConfigurationProvider>
      </StrictMode>
    );
  }
});
